// extracted by mini-css-extract-plugin
module.exports =  {"AttributeInfo":"AttributeInfo__bUhio"};